import React from 'react';

const SearchBox = ({ styleName, placeholder, onChange, value }) => {
  return (
    <div className={`gx-search-bar ${styleName}`}>
      <div style={{ background: 'green' }} className="gx-form-group">
        <input
          style={{ background: 'green' }}
          className="ant-input"
          type="search"
          placeholder={placeholder}
          onChange={onChange}
          value={value}
        />
        {/* <span className="gx-search-icon gx-pointer"> */}
        {/* <SearchOutlined /> */}
        {/* <i
            className="icon icon-search"
            style={{ color: 'blue', background: 'orange' }}
          /> */}
        {/* </span> */}
      </div>
    </div>
  );
};
export default SearchBox;

SearchBox.defaultProps = {
  styleName: '',
  value: '',
};
